import {ResponseVehicle} from '../types/api';
import { Language } from '../types/language';

export const getVehicleName = (vehicle: ResponseVehicle, lang: Language) => {
  const isVW = vehicle?.make === 'Volkswagen';
  const isFrench = lang === 'fr';
  const {year, make, model, trim} = vehicle;

  if (!isVW && isFrench) {
    return `${make} ${model} ${trim} ${year}`;
  } else if (isVW && isFrench) {
    return `${model} ${trim} ${year}`;
  } else if (isVW && !isFrench) {
    return `${year} ${model} ${trim}`;
  }

  return `${year} ${make} ${model} ${trim}`;
};
